import { createAction } from '@reduxjs/toolkit'

export clearGraph = createAction('graph/cleared')
export removeGraphEdge = createAction('graph/edgeRemoved')
export removeGraphEdges = createAction('graph/edgesRemoved')
export removeGraphNode = createAction('graph/nodeRemoved')
export removeGraphNodes = createAction('graph/nodesRemoved')
export setDevtoolsEnabled = createAction('graph/devtoolsEnabledSet')
export setGraphNodeView = createAction('graph/nodeViewSet')
export setGraphGroups = createAction('graph/graphGroupsSet')
export setGraphNodes = createAction('graph/graphDataSet')
export updateIsAbstract = createAction('graph/isAbstractUpdated')
export updateGraphGroups = createAction('graph/graphGroupsUpdated')
export updateGraphNodes = createAction('graph/graphNodesUpdated')
export setNodeLimit = createAction('graph/nodeLimitSet')
